import digitalSolutionsFader from '../components/digital-solutions-header-fader';

export default {
	namespace: 'digitalsolutions',
	beforeEnter() {

	},
	afterEnter(barba) {
		console.log('View: digital solutions page')
		digitalSolutionsFader(barba)
	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
